import { render, staticRenderFns } from "./PublicationVocabularyModal.vue?vue&type=template&id=702703c6&scoped=true&"
import script from "./PublicationVocabularyModal.vue?vue&type=script&lang=js&"
export * from "./PublicationVocabularyModal.vue?vue&type=script&lang=js&"
import style0 from "./PublicationVocabularyModal.vue?vue&type=style&index=0&id=702703c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702703c6",
  null
  
)

export default component.exports